



import React, {useState,useEffect} from 'react';

import axios from 'axios';
import "./CourseSpot.css"
//import img1 from "../../Images/Landing.jpg"
import img1 from "../../Images/CourseGenereric.jpg"
import { Link } from 'react-router-dom';
import { FontAwesomeIcon, } from '@fortawesome/react-fontawesome';
import { fab,faFacebook, faTwitter,faInstagram,faYoutube, faLinkedin, faCheck } from '@fortawesome/free-solid-svg-icons'
import {faHeart,faPhone,faLocationPin,faTools,faUserShield ,faTimes,faBars } from '@fortawesome/free-solid-svg-icons'
//import Timeline from "../../Components/Timeline/index"
import Timeline from "../../Components/Test/Timeline"
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

// import { Link } from "react-router-dom";




function CourseSpot({courseID,onButtonClick}) { 

        const [courses, setCourses] = useState();
        const [Intakes, setIntakes] = useState([]);
        const [content, setContent] = useState();
        const [currentDate, setCurrentDate] = useState()


        // const getCurrentIntake = (courscode) => {
               
        //         Intakes.map((intk, index)=>{

        //                 // console.log("course code ",intk.CourseCode)
        //                 // console.log("filter",courscode)
        //                 // console.log("whole",intk)
                        

        //             if((intk.CourseCode == courscode ) && (intk.Current == 'true')){
        //                 console.log("Right intake",intk.StartDate)
        //                 //setCurrentDate(new Date(intk.StartDate))

        //                 return intk.StartDate;
        //             } else{

        //                 console.log("Wrong intake")
                        
        //             }

               

        //         })

              

        // }


        const scrollToSection = (id) => {
          document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
          // toggleMenu();
        };

        const getCurrentIntake = (courscode) => {
                const intake = Intakes.find((intk) => {
                    // Check if the current intake matches the course code and is current
                    if ((intk.CourseCode == courscode) && (intk.Current == 'true')) {
                        // console.log("Right intake", intk.StartDate);
                        return true;
                    } else {
                        // console.log("Wrong intake");
                        return false;
                    }
                });
            
                // If an intake was found, return its start date; otherwise, return undefined
                // return intake ? intake.StartDate : undefined;
                if (intake) {
                        const startDate = new Date(intake.StartDate);
                
                        // Extract the day, month, and year
                        const day = startDate.getUTCDate();
                      //  const month = startDate.getUTCMonth() + 1; // Months are zero-based
                        const year = startDate.getUTCFullYear();
                   
                         const month = startDate.toLocaleString('default', { month: 'short' });


                
                        return { day, month, year };
                    } else {
                        return undefined;
                    }

            };
            

          
        //pull course content
        useEffect(()=>{
                async function getContent (){                    
                   try{                              
                     const response =   await axios.get(process.env.REACT_APP_BASEURL+'/api/courses/content')
         
                                if(response && response?.status == 200){  
                                  console.log("content",response)                  
                                   setContent(response?.data);
                  
                                }
         
                   }catch(e){
                         // console.log("catch error",e)
                   }
                               
                }                
                  
                getContent()                  
         
             },[])

        //pull courses
        useEffect(()=>{
                async function getCourses (){                    
                   try{                              
                     const response =   await axios.get(process.env.REACT_APP_BASEURL+'/api/courses/')
         
                                if(response && response?.status == 200){                    
                                    setCourses(response?.data);
                  
                                }
         
                   }catch(e){
                         // console.log("catch error",e)
                   }
                               
                }                
                  
                 getCourses()                  
         
             },[])



             useEffect(()=>{
                async function getIntakes(){ 
                     
                   try{      
         
                     const response =   await axios.get(process.env.REACT_APP_BASEURL+'/api/Intake')
         
         
                     console.log("am in useffect")
         
                     // if (courses){
         
                       if(response && response?.status == 200){ 
         
                           console.log("Intakes",response.data)
                           setIntakes(response?.data);
         
                       } else{
                        //  setCourses(coursesType)
                        //  console.log("Error req Application")
                       }
                      
         
                   }catch(e){
                    //  setCourses(coursesType)
                        //  console.log("Error in intakes")
                   }
                      
                }
         
                getIntakes()
                  
         
             },[])


  
 

  return <>
        <div className='CourseSpotCover'>
            
            <div className='OpeningTag'>    

                  <p>This course is part our short Courses track</p>

            </div>

            {courses && courses.map((item,index)=>{
                return(

            (item.CourseCode == courseID) && <div key={index} className='respectiveContentSection'>
              

                

                    <div className='ImageDescription'>
                        <div className='imgCover'>
                             <img src={img1} />
                        </div>
                        <div className='imgWording'>
                             <h2>
                                 {/* Introduction to Digital Marketing Strategy */}
                                 {item?.CourseName}
                             </h2>

                             <div className='cardForeword'>
                                  <p>{item?.DescriptionTwo}</p>

                                  {/* <a className='linkItems' onClick={() => scrollToSection('shopping')}> */}
                                <div className='btnSection'>  

                                        <button onClick={() => scrollToSection('outline')} >Course Outline</button>
                                        <button onClick={() => scrollToSection('info')}>Get more info</button>
                                  
                                </div>
                            </div>
                        </div>

                        
                       

                    </div>

                    <div className='CardDescription'>   
                    <div className='CardDescriptionCover'>

                        <h1>  {item?.CourseName}</h1>
                        <p><b>{`ZMK ${item?.Cost}`}</b></p>
                        <p>{`Next ${item?.Duration_Weeks} week session starts ${getCurrentIntake(courseID)?.month} ${getCurrentIntake(courseID)?.day}`}</p>
                        {/* <Link className='LinkItems' to={`/Courses/${index?.CourseCode}`}> */}
                        <Link className='LinkItems' to={`/Home`}>
                                 <button onClick={()=>{onButtonClick(item)}}><h3>Apply</h3></button>
                        </Link>
                        
                        <div className='cardForeword'>
                             <p>{item?.Description}</p>
                             {/* <p>Develop digital marketing strategies that reach and retain customers.</p> */}
                        </div>
                        <div className='SquareCards'>

                                <div className='FirstSquareCards'>      

                                        <div className='respectivecard'>    

                                                <h1>{item?.Duration_Weeks}</h1>
                                                <p>weeks</p>
                                        </div>
                                        <div className='respectivecard'>    

                                                <h1>4</h1>
                                                <p>hours per week</p>
                                        </div>

                                </div>
                                <div className='SecondSquareCardsff'>      

                                        <div className='respectivecard'>    

                                                <h1>5+</h1>
                                                <p>Modules</p>
                                        </div>
                                        <div className='respectivecard'>    

                                                <h1>Online</h1>
                                                <p>Multiple cohorts</p>
                                        </div>

                                </div>

                        </div>
                        </div>

                    </div>

                    

            </div>

        )})}


        <div className='demospace' id='outline'>   

               <div className='courseoverviewnew' >
                    <h2>Course overview</h2>
                            
                  </div> 

                <VerticalTimeline>   

                  {content && content.map((item,index)=>{

        

                          return(
                                (item?.Coursecode == courseID) &&
                            
                                <VerticalTimelineElement
                                  className="vertical-timeline-element--work"
                                  //contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                                  contentStyle={{ background: '#003300', color: 'white' }}
                                  contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
                                  date="2011 - present"
                                  iconStyle={{ background: 'gold', color: 'green' }}
                                  //iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                                  //icon={}
                                >
                                  <h3 style={{color: "white"}} className="vertical-timeline-element-title">{`${item?.Durationcategory} ${item?.Durationinstatnce}`}</h3>
                                  {/* <h4 className="vertical-timeline-element-subtitle">Miami, FL</h4> */}
                                  <p>
                                    {item.Content}
                                  </p>
                                </VerticalTimelineElement>
                          
                          
                                
                              )
                                  
                  })}

        </VerticalTimeline>

        {/* <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
            contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
            date="2011 - present"
            iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
            //icon={}
          >
            <h3 className="vertical-timeline-element-title">WEEK 1</h3>
            <h4 className="vertical-timeline-element-subtitle">Miami, FL</h4>
            <p>
              Creative Direction, User Experience, Visual Design, Project Management, Team Leading
            </p>
          </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    date="2010 - 2011"
    iconStyle={{ background: 'green', color: '#fff', fontSize: '78px' }}
    // icon={<WorkIcon />}
  >
    <h3 className="vertical-timeline-element-title">Art Director</h3>
    <h4 className="vertical-timeline-element-subtitle">San Francisco, CA</h4>
    <p>
      Creative Direction, User Experience, Visual Design, SEO, Online Marketing
    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    date="2008 - 2010"
    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
    //icon={<WorkIcon />}
  >
    <h3 className="vertical-timeline-element-title">Web Designer</h3>
    <h4 className="vertical-timeline-element-subtitle">Los Angeles, CA</h4>
    <p>
      User Experience, Visual Design
    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    date="2006 - 2008"
    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
    //icon={<WorkIcon />}
  >
    <h3 className="vertical-timeline-element-title">Web Designer</h3>
    <h4 className="vertical-timeline-element-subtitle">San Francisco, CA</h4>
    <p>
      User Experience, Visual Design
    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--education"
    date="April 2013"
    iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
    //icon={<SchoolIcon />}
  >
    <h3 className="vertical-timeline-element-title">Content Marketing for Web, Mobile and Social Media</h3>
    <h4 className="vertical-timeline-element-subtitle">Online Course</h4>
    <p>
      Strategy, Social Media
    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--education"
    date="November 2012"
    iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
    //icon={<SchoolIcon />}
  >
    <h3 className="vertical-timeline-element-title">Agile Development Scrum Master</h3>
    <h4 className="vertical-timeline-element-subtitle">Certification</h4>
    <p>
      Creative Direction, User Experience, Visual Design
    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--education"
    date="2002 - 2006"
    iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
    //icon={<SchoolIcon />}
  >
    <h3 className="vertical-timeline-element-title">Bachelor of Science in Interactive Digital Media Visual Imaging</h3>
    <h4 className="vertical-timeline-element-subtitle">Bachelor Degree</h4>
    <p>
      Creative Direction, Visual Design
    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
    //icon={<StarIcon />}
  />
</VerticalTimeline> */}
                           
        </div>
            {/* close of card content */}

            <div>
                
            </div>

            {/* Start of course resources overall container */}

            {/* <div className='CourseResources'>       
                    
                    <div className='CourseResourcesKeyConcepts'>    

                        <div className='CMSWording'>
                            
                            <h3 className="solidLine">KEY CONCEPTS</h3>

                        </div>
                        
                        <div className='courseResPoints'>   

                            <div className='courseResPointsContCover'>
                                    <div className='courseResPointsContainer'>  
                                            <div className='respectivePoint'>
                                                    <FontAwesomeIcon className='fontAweTick' icon={faCheck}/>
                                                    <p>Understand how marketing has evolved and what’s ahead based on real-world insights from brands, agencies, expert practitioners, and faculty</p>
                                            </div>
                                            <div className='respectivePoint'>
                                                    <FontAwesomeIcon className='fontAweTick' icon={faCheck}/>
                                                    <p>Understand how marketing has evolved and what’s ahead based on real-world insights from brands, agencies, expert practitioners, and faculty</p>
                                            </div>

                                    </div>
                                    <div className='courseResPointsContainer'>  

                                    <div className='respectivePoint'>
                                                     <FontAwesomeIcon className='fontAweTick' icon={faCheck}/>
                                                    <p>Understand how marketing has evolved and what’s ahead based on real-world insights from brands, agencies, expert practitioners, and faculty</p>
                                            </div>
                                            <div className='respectivePoint'>
                                                     <FontAwesomeIcon className='fontAweTick' icon={faCheck}/>
                                                    <p>Understand how marketing has evolved and what’s ahead based on real-world insights from brands, agencies, expert practitioners, and faculty</p>
                                            </div>

                                    </div>
                            </div>

                        </div>

                    </div> 




            </div> */}
            {/* CLOSE OF COURSE RESOURCES */}

            {/* START OF ABOUT LECTURER */}
            {/* <div className='CourseSpotLectuerCover'>    

                        <div className='CMSWording'>
                            
                            <h3 className="solidLine">ABOUT THE LECTURER</h3>

                        </div>

                <div className='LecturerSpotCardCover'>  
                <div className='LecturerSpotCard'>  
                        <div className='LecturerSpotImage'> 

                            <img src={img1} />

                        </div>
                        <div className='LecturerSpotName'>
                                <h3>Prof. Jere Mulenga</h3>
                        </div>
                        <div className='LecturerMajor'>
                                <h3>Strategy & Execution</h3>
                        </div>
                        <div className='LecturerSpotForeword'>  

                                <p>"You’ll develop practical digital marketing skills and frameworks you can immediately apply to your role and organization—making you more marketable and helping advance your career."</p>

                        </div>

                </div>
                </div>


            </div> */}

            {/* END ABOUT LECTURER */}
            {/* START OF ELIGIBITY */}
            {courses && Intakes && courses.map((item,index)=>{

                
        //       console.log("return variable",getCurrentIntake(courseID))

        //         getCurrentIntake(courseID)
                return(

            (item.CourseCode == courseID) &&

                        <div className='ElgibilityCover'>       

                    <div className=''>

                    </div>

                    <div className='EligibiityContainer'>   

                            <div className='EligibiityCard'>    

                                    <div className='Starting'>
                                             <p>Starting</p>
                                    </div>
                                   
                                    <div className='Month'>
                                        <h3>{getCurrentIntake(courseID)?.month}</h3>
                                    </div>
                                    <div className='Date'>

                                            <h3>{getCurrentIntake(courseID)?.day}</h3>

                                    </div>
                                    <div className='PriceAndDuration'>  

                                            <div className='ChildF'>
                                                        <p>{`${item?.Duration_Weeks} week(s)`} </p>
                                              </div>
                                            <div className='ChildF'>

                                                        <p><b>{`ZMK ${item?.Cost}`}</b></p>


                                              </div>

                                    </div>
                                    <div className='Deadline'>
                                         <p>{`Apply Before: ${getCurrentIntake(courseID)?.day} ${getCurrentIntake(courseID)?.month} ${getCurrentIntake(courseID)?.year}`}</p>
                                    </div>
                                    <div className='ApplyNowCTA'>   
                                       <Link className='LinkItems' to={`/Home`}>
                                          <button>Apply Now</button>
                                        </Link>
                                            

                                    </div>

                            </div>

                    </div>

            </div>

)})}
            

            {/* close if eligibiity cover */}
            

        </div>
       
    
  </>
  
  ;
}

export default CourseSpot;